// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// third-party
import { presetDarkPalettes, presetPalettes, PalettesProps } from '@ant-design/colors';

// project import
import ThemeOption from './theme';

// types
import { PaletteThemeProps } from 'types/theme';
import { PresetColor, ThemeMode } from 'types/config';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode: ThemeMode, presetColor: PresetColor) => {
  const colors: PalettesProps = mode === 'dark' ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  if (mode === 'dark') {
    greyPrimary = [
      'rgb(19, 22, 29)',
      'rgb(42, 46, 60)',
      '#313745',
      '#595959',
      '#8c8c8c',
      '#bfbfbf',
      '#d9d9d9',
      '#f0f0f0',
      '#f5f5f5',
      '#fafafa',
      '#ffffff'
    ];
    // greyPrimary.reverse();
    greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    greyConstant = ['rgb(33, 35, 47)', '#d3d8db'];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor: PaletteThemeProps = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: mode === 'dark' ? alpha(paletteColor.grey[900]!, 0.87) : paletteColor.grey[700],
        secondary: mode === 'dark' ? alpha(paletteColor.grey[900]!, 0.45) : paletteColor.grey[500],
        disabled: mode === 'dark' ? alpha(paletteColor.grey[900]!, 0.1) : paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: mode === 'dark' ? alpha(paletteColor.grey[900]!, 0.05) : paletteColor.grey[200],
      background: {
        paper: mode === 'dark' ? paletteColor.grey[100] : paletteColor.grey[0],
        default: paletteColor.grey.A50
      },
      lightgreen: {
        main: '#90EE90'
      },
      forestgreen: {
        main: '#459A2C',
        dark: '#377B23',
        darker: '#237804'
      },
      firebrick: {
        main: '#C9342F'
      },
      skyblue: {
        main: '#87CEEB'
      },
      gold: {
        main: '#FFD700'
      },
      crimson: {
        main: '#DC143C'
      },
      darkgray: {
        main: '#979797'
      },
      limegreen: {
        main: '#32CD32'
      },
      lightskyblue: {
        main: '#87CEFA'
      },
      lightsalmon: {
        main: '#FFA07A'
      },
      salmon: {
        main: '#FA8072'
      },
      sandybrown: {
        main: '#F4A460'
      },
      dodgerblue: {
        main: '#1E90FF'
      },
      springgreen: {
        main: '#00FF7F'
      },
      lightcoral: {
        main: '#F08080'
      },
      orangered: {
        main: '#FF4500'
      },
      gainsboro: {
        main: '#DCDCDC'
      },
      lightseagreen: {
        main: '#20B2AA'
      },
      maroon: {
        main: '#800000',
        dark: '#660000 '
      },
      turquoise: {
        main: '#40E0D0'
      },
      slateblue: {
        main: '#6A5ACD',
        dark: '#483D8B',
        lighter: '#706ce6'
      },
      royalblue: {
        main: '#4169E1'
      },
      darkcyan: {
        main: '#008B8B'
      },
      aliceblue:{
      main: '#f0f6ff'
      }
    }
  });
};

export default Palette;
